import React, { useEffect, useState } from "react";
import LicensePlateModal from "./licensePlate-modal";
import { useMsal } from "@azure/msal-react";
import ApiProvider from "../../../apiProvider";
import Plates from "./plates";

const LicensePlates = ({ setMenuOptions }) => {
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [licensePlates, setLicensePlates] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedPlate, setSelectedPlate] = useState();

    useEffect(() => {
        loadPlates();
        setMenuOptions("Plates");
    }, []);

    function onCloseModal() {
        loadPlates();
        setShowModal(false);
    }

    async function loadPlates() {
        setLoading(true);
        try {
            const result = await apiProvider.Get("LicensePlate");
            if (!result.error) {
                setLicensePlates(result);
                setError(null); // Clear any previous errors
            } else {
                setError("Failed to load license plates. Please try again later.");
            }
        } catch (err) {
            setError("An error occurred while fetching license plates.");
        }
        setLoading(false);
    }

    async function deletePlate(plate) {
        await apiProvider.Delete(`LicensePlate/${plate.id}`);
        await loadPlates();
    }

    return (
        <div>
            <Plates
                setShowModal={setShowModal}
                setSelectedPlate={setSelectedPlate}
                licensePlates={licensePlates}
                deletePlate={deletePlate}
                loading={loading} // Pass loading state
                error={error} // Pass error state
            />
            {showModal && (
                <LicensePlateModal
                    show={showModal}
                    setShow={setShowModal}
                    onCloseModal={onCloseModal}
                    plate={selectedPlate}
                />
            )}
        </div>
    );
};

export default LicensePlates;
